import { ShareInfoFragment, useShareRestoreMutation } from '@sketch/gql-types'
import { ErrorHandler } from '@sketch/tracing'
import { handleShareRestored } from './handlers'

export interface UseShareRestoreProps {
  identifier: string
  onCompleted: (share: ShareInfoFragment) => void
  onError: (message: string) => void
}

export const useShareRestore = (props: UseShareRestoreProps) => {
  const { identifier, onCompleted, onError } = props

  return useShareRestoreMutation({
    redirectErrors: true,
    variables: { identifier },
    onCompleted: data => {
      if (!data?.shareRestore?.share) {
        onError('Something is wrong, please contact our support team')
        ErrorHandler.shouldNeverHappen('shareRestore')
        return
      }

      onCompleted(data.shareRestore.share)
    },
    update: (cache, { data }) => {
      const workspaceIdentifier =
        data?.shareRestore?.share?.workspace.identifier || ''

      const projectIdentifier = data?.shareRestore?.share?.project?.identifier

      if (workspaceIdentifier === '') {
        ErrorHandler.shouldNeverHappen.invalidMutationData('shareRestore')
      }

      handleShareRestored({
        cache,
        identifier,
        workspaceIdentifier,
        projectIdentifier,
      })
    },
    onError: graphqlError => {
      onError(graphqlError.message)
    },
  })
}
